// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageSquare_root__2M5VP","image":"ImageSquare_image__1qzP6","deleteButton":"ImageSquare_deleteButton__lljZ3"};